/**
 * Environment configuration
 * Provides type-safe access to environment variables
 */

export const config = {
  api: {
    url: import.meta.env.VITE_API_URL || 'http://localhost:3001',
    timeout: parseInt(import.meta.env.VITE_API_TIMEOUT || '30000', 10),
  },
  supabase: {
    url: import.meta.env.VITE_SUPABASE_URL || '',
    anonKey: import.meta.env.VITE_SUPABASE_ANON_KEY || '',
  },
  stripe: {
    publishableKey: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || '',
  },
  analytics: {
    id: import.meta.env.VITE_ANALYTICS_ID || '',
    enabled: import.meta.env.VITE_ENABLE_ANALYTICS === 'true',
  },
  features: {
    premium: import.meta.env.VITE_ENABLE_PREMIUM_FEATURES === 'true',
    offline: import.meta.env.VITE_ENABLE_OFFLINE_MODE === 'true',
    pwa: import.meta.env.VITE_ENABLE_PWA === 'true',
  },
} as const;

/**
 * Validates that all required environment variables are set
 */
export function validateConfig(): void {
  const required = [
    { key: 'VITE_API_URL', value: config.api.url },
    { key: 'VITE_SUPABASE_URL', value: config.supabase.url },
    { key: 'VITE_SUPABASE_ANON_KEY', value: config.supabase.anonKey },
  ];

  const missing = required.filter((item) => !item.value);

  if (missing.length > 0) {
    console.warn(
      'Missing required environment variables:',
      missing.map((item) => item.key).join(', ')
    );
  }
}
